import React from 'react';
import PropTypes from 'prop-types';
import './TextInput.scss';
import InputControl from '../InputControl/InputControl';

const TextInput = ({
  id,
  classes: modifierClasses,
  label,
  type,
  name,
  value,
  labelModifier,
  condensed,
  disabled,
  readOnly,
  error,
  microcopy,
  onChange,
  onBlur,
  maxLength,
  inputRef,
  hideLabel,
  attributes,
}) => {
  let additionalProps = {};
  if (error) {
    additionalProps = { ...additionalProps, 'aria-invalid': 'true' };
  }
  if (labelModifier === 'required') {
    additionalProps = { ...additionalProps, 'aria-required': 'true' };
  }
  const inputType = type;
  let inputMode;
  if (type === 'password') {
    inputMode = 'text';
  } else {
    inputMode = type;
  }

  const handleOnChange = (e) => {
    onChange(e.target.value);
  };

  const handleOnBlur = (e) => {
    if (onBlur) {
      onBlur(e.target.value);
      return;
    }
    onChange(e.target.value);
  };

  const classes = ['input-control--input--wrap'];

  if (condensed) {
    classes.push('input-control--condensed');
  }


  const normalizedPropClasses =
    modifierClasses instanceof Array
      ? modifierClasses
      : [modifierClasses];

  const controllerClasses = [
    'axiom-text-input',
    ...normalizedPropClasses,
  ];

  return (
    <InputControl
      id={id}
      classes={controllerClasses}
      label={label}
      labelModifier={labelModifier}
      error={error}
      microcopy={microcopy}
      hideLabel={hideLabel}
    >
      <div data-testid='wrap' className={classes.join(' ')}>
        <input
          id={id}
          data-testid='input'
          name={name}
          value={value}
          aria-describedby={
            error || microcopy ? `${id}_messages` : null
          }
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          disabled={disabled}
          readOnly={readOnly}
          className={`axiom-text-input--input${readOnly ? ' read-only' : ''}`}
          type={inputType}
          inputMode={inputMode}
          maxLength={maxLength}
          ref={inputRef}
          {...attributes}
          {...additionalProps}
        />
      </div>
    </InputControl>
  );
};

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'password', 'url']),
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  labelModifier: PropTypes.oneOf(['required', 'optional']),
  condensed: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  error: PropTypes.string,
  microcopy: PropTypes.string,
  maxLength: PropTypes.number,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  hideLabel: PropTypes.bool,
  attributes: PropTypes.objectOf(PropTypes.any),
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

TextInput.defaultProps = {
  classes: [],
  type: 'text',
  labelModifier: undefined,
  condensed: false,
  disabled: false,
  readOnly: false,
  error: undefined,
  microcopy: undefined,
  maxLength: undefined,
  inputRef: undefined,
  onBlur: undefined,
  hideLabel: false,
  attributes: {},
};

export default TextInput;
